var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge"},[_c('font-icon',{attrs:{"name":_vm.iconParams.iconName,"style-name":_vm.iconParams.style}}),_c('span',{staticClass:"badge__text"},[_vm._v(_vm._s(_vm.iconParams.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }